<template>
  <div class="insight-news">
    <div class="insight-news__header">
      <div class="insight-news__header-title">Insights</div>
    </div>
    <div class="insight-news__line"></div>
    <insight-panel text="See All" :href="allArticlesLink" :away="allArticlesAway">
      <div class="insight-news__articles">
        <insight-link
          v-for="link in analysis"
          :key="link.title"
          :title="link.title"
          :href="createLink(link.url)"
          :date="createDate(link.date)"
          :url="link.url"
        >
        </insight-link>
      </div>
    </insight-panel>
  </div>
</template>
<script src="./insight-news.js"></script>
<style src="./insight-news.scss" lang="scss"></style>
